// admin-operations/mutation-diff.schema.ts
import { z } from "zod";
var RowSnapshotSchema = z.object({
  /** Fully-qualified table name, e.g. 'delivery.order_partition_items'. */
  table: z.string().min(1),
  /** Primary key columns identifying the row, e.g. { id: 'uuid-...' }. */
  primaryKey: z.record(z.string(), z.unknown()),
  /** Only the columns this operation actually touched. */
  columns: z.record(z.string(), z.unknown())
});
var MutationDiffSchema = z.object({
  before: z.array(RowSnapshotSchema),
  after: z.array(RowSnapshotSchema)
});
var OperationResponseSchema = z.object({
  diff: MutationDiffSchema,
  auditLogId: z.string().uuid().nullable(),
  requestId: z.string()
});

// admin-operations/admin-operation-log.schema.ts
import { z as z2 } from "zod";
var DbAdminOperationLogSchema = z2.object({
  id: z2.string().uuid(),
  admin_id: z2.string().uuid(),
  operation: z2.string().min(1),
  partition_id: z2.string().uuid().nullable(),
  partition_item_ids: z2.array(z2.string().uuid()).nullable(),
  batch_ids: z2.array(z2.string().uuid()).nullable(),
  inventory_item_id: z2.string().uuid().nullable(),
  client_request_id: z2.string().nullable(),
  reason: z2.string().nullable(),
  executed_at: z2.union([z2.string(), z2.date()]),
  before: MutationDiffSchema.shape.before,
  after: MutationDiffSchema.shape.after
});
var AdminOperationLogSchema = z2.object({
  id: z2.string().uuid(),
  adminId: z2.string().uuid(),
  operation: z2.string().min(1),
  partitionId: z2.string().uuid().nullable(),
  partitionItemIds: z2.array(z2.string().uuid()).nullable(),
  inventoryPackageIds: z2.array(z2.string().uuid()).nullable(),
  inventoryItemId: z2.string().uuid().nullable(),
  clientRequestId: z2.string().nullable(),
  reason: z2.string().nullable(),
  executedAt: z2.date(),
  before: MutationDiffSchema.shape.before,
  after: MutationDiffSchema.shape.after
});
var AdminOperationLogDtoSchema = z2.object({
  id: z2.string().uuid(),
  adminId: z2.string().uuid(),
  operation: z2.string().min(1),
  partitionId: z2.string().uuid().nullable(),
  partitionItemIds: z2.array(z2.string().uuid()).nullable(),
  inventoryPackageIds: z2.array(z2.string().uuid()).nullable(),
  inventoryItemId: z2.string().uuid().nullable(),
  clientRequestId: z2.string().nullable(),
  reason: z2.string().nullable(),
  executedAt: z2.string().datetime(),
  before: MutationDiffSchema.shape.before,
  after: MutationDiffSchema.shape.after
});
var AdminOperationResultSchema = z2.discriminatedUnion("kind", [
  z2.object({
    kind: z2.literal("committed"),
    diff: MutationDiffSchema,
    auditLogId: z2.string().uuid()
  }),
  z2.object({
    kind: z2.literal("previewed"),
    diff: MutationDiffSchema,
    auditLogId: z2.null()
  }),
  z2.object({
    kind: z2.literal("idempotent_replay"),
    diff: MutationDiffSchema,
    auditLogId: z2.string().uuid()
  })
]);
export {
  AdminOperationLogDtoSchema,
  AdminOperationLogSchema,
  AdminOperationResultSchema,
  DbAdminOperationLogSchema,
  MutationDiffSchema,
  OperationResponseSchema,
  RowSnapshotSchema
};
